import { render } from "./SidebarStatus.vue?vue&type=template&id=190d9772"
import script from "./SidebarStatus.vue?vue&type=script&lang=js"
export * from "./SidebarStatus.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_2839a0f4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__